import { NavLink } from "react-router-dom";
import "./routingList.css";
import { path } from "../../api/data/consts";

const routes = [
  {
    id: "about",
    label: "О проекте",
    to: path.startPage,
  },
  {
    id: "cards",
    label: "Карты",
    to: path.cardListPage,
  },
  {
    id: "spreads",
    label: "Расклады",
    to: path.spreadsPage,
  },
];

export const RoutingList = () => (
  <nav
    className="routing-list"
    aria-label="Основная навигация"
  >
    {routes.map(
      ({
        id,
        label,
        to,
      }) => (
        <NavLink
          key={id}
          to={to}
          end={id === "about"}
          className={({
            isActive,
          }) =>
            isActive
              ? "routing-list__item routing-list__item--active"
              : "routing-list__item"
          }
        >
          <span className="routing-list__marker" />

          <span>
            {label}
          </span>
        </NavLink>
      )
    )}
  </nav>
);

